import { Grid, Chip, Stack } from '@mui/material';
import useStore from '../zustand/useStore';
const FilterChips = () => {
  const { filters, setFilter } = useStore((state) => ({
    filters: state.filters,
    setFilter: state.setFilter,
  }));

  const filtersarray = ['search', 'date', 'country', 'type'];
  return (
    <Grid container style={{ width: '100%', margin: '3rem auto 0' }}>
      <Grid item xs={12}>
        <Stack direction="row" spacing={1}>
          {filtersarray.map((filter) => {
            if (filters[filter] !== '') {
              return (
                <Chip
                  key={filter}
                  label={`${
                    filter.charAt(0).toUpperCase() + filter.substring(1)
                  }: ${filters[filter]}`}
                  onDelete={() => setFilter(filter, '')}
                />
              );
            }
            return null;
          })}
        </Stack>
      </Grid>
    </Grid>
  );
};

export default FilterChips;
